<!-- UNUSED -->
<div class="main mat-typography mat-body mat-app-background">
  <div class='div-left'>
    <div>
      <h3 class="sub-header">
        <slot name="text_two">Select Market</slot>
      </h3>
      <div class='sub-text'>
        <slot name="subText_two">
          Select the market of the product you're looking for.
        </slot>
      </div>
    </div>
    @if (loginInfo.basicUserInfo.individual) {
      <mat-card appearance="outlined">
        <div class="text-container">
          <div class="text-div" >Individual & Family</div>
          <div class="select-div" (click)="redirectTo(linesOfBusiness.individual)">SELECT</div>
        </div>
      </mat-card>
    }
    @if (loginInfo.basicUserInfo.medicare) {
      <mat-card appearance="outlined">
        <div class="text-container">
          <div class="text-div" >Medicare</div>
          <div class="select-div" (click)="redirectTo(linesOfBusiness.senior)">SELECT</div>
        </div>
      </mat-card>
    }
    @if (loginInfo.basicUserInfo.smallgroup) {
      <mat-card appearance="outlined">
        <div class="text-container">
          <div class="text-div" >Small Group</div>
          <div class="select-div" (click)="redirectTo(linesOfBusiness.smallGroup)">SELECT</div>
        </div>
      </mat-card>
    }
  </div>
  <div class='div-right'>
    <slot name="img_welcome"></slot>
  </div>
</div>
